import { StatusBar } from "expo-status-bar";
import { Platform, StyleSheet, Text, View } from "react-native";
import { useFonts } from "expo-font";

import { AuthProvider } from "./context/AuthContext";
import AppNav from "./navigation/AppNav";
import {
  SafeAreaProvider,
  useSafeAreaInsets,
} from "react-native-safe-area-context";
import Notification from "./components/Notification";
import { RootSiblingParent } from "react-native-root-siblings";
import { RequestFormProvider } from "./context/RequestFormContext";

const CustomStatusBar = ({
  backgroundColor,
  color,
  barStyle = "dark-content",
  style = "auto",
}) => {
  const insets = useSafeAreaInsets();

  if (Platform.OS === "ios")
    return (
      <View style={{ height: insets.top, backgroundColor }}>
        <StatusBar
          hidden={false}
          animated={true}
          backgroundColor={backgroundColor}
          barStyle={barStyle}
          style={style}
        />
      </View>
    );
  else
    return (
      <StatusBar
        hidden={false}
        animated={true}
        backgroundColor={backgroundColor}
        barStyle={barStyle}
        style={style}
      />
    );
};

const App = () => {
  const [fontsLoaded] = useFonts({
    "Roboto-Regular": require("./assets/fonts/Roboto-Regular.ttf"),
    "Roboto-Medium": require("./assets/fonts/Roboto-Medium.ttf"),
    "Roboto-Italic": require("./assets/fonts/Roboto-Italic.ttf"),
    "Roboto-MediumItalic": require("./assets/fonts/Roboto-MediumItalic.ttf"),
    "Roboto-Bold": require("./assets/fonts/Roboto-Bold.ttf"),

    "MaterialIcons": require("./assets/vectoricons/fonts/MaterialIcons.ttf"),
    "Ionicons": require("./assets/vectoricons/fonts/Ionicons.ttf"),
    "Feather": require("./assets/vectoricons/fonts/Feather.ttf"),
  });


  if (!fontsLoaded) {
    return null;
  }
  return (
    <RootSiblingParent>
      <SafeAreaProvider>
        <CustomStatusBar backgroundColor="#407daf" />
        <AuthProvider>
          <RequestFormProvider>
            <Notification>
              <AppNav />
            </Notification>
          </RequestFormProvider>
        </AuthProvider>
      </SafeAreaProvider>
    </RootSiblingParent>
  );
};

export default App;
